<template>
  <div id="center">
    <div class="up">
      <div
        class="item"
        v-for="item in titleItem"
        :key="item.title"
      >
        <dv-border-box-12 style="height: 100px">
        <div class="titleDiv" style="padding: 10px">
        <el-tag class="tileSize" >{{ item.title }}</el-tag>
        </div>
          <div>
          <dv-digital-flop
            class="dv-dig-flop mt-2"
            :config="item.number"
          />
        </div>
        </dv-border-box-12>
      </div>
    </div>
    <div class="down">
      <div ref="chartContainer" style="height: 100%;"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import autoResize from "@jiaminghi/data-view/lib/mixin/autoResize";

export default {
  name: "companyDevice",
  mixins: [autoResize],
  props: [],
  data() {
    return {
      titleItem: [
        {
          title: '设备数量',
          number: {
            number: [4981],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}个',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '设备种类',
          number: {
            number: [21],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}种',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '数据流',
          number: {
            number: [2897981],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}条',
            style: {
              fontSize: 26
            }
          }
        },
      ],
    }
  },
  watch: {

  },
  components: {
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chartDom = this.$refs.chartContainer;
      const myChart = echarts.init(chartDom, 'dark', {
        renderer: 'canvas',
        useDirtyRect: false,
      });

      const option = {
        backgroundColor: '',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        grid:{ // 让图表占满容器
          top:"0",
          left:"0",
          right:"0",
          bottom:"0"
        },

        series: [
          {
            name: '设备所在地',
            type: 'pie',
            selectedMode: 'single',
            radius: [0, '30%'],
            label: {
              position: 'inner',
              fontSize: 18,
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 1548, name: '4合1' },
              { value: 775, name: '臭氧输送器' },
              { value: 679, name: '臭氧传感器'},
            ],
          },
          {
            name: '设备来源',
            type: 'pie',
            radius: ['45%', '60%'],
            labelLine: {
              length: 30,
            },
            label: {
              normal: {
                formatter: function(arg){return arg.name + '\n'+'设备数量:'+arg.value},
                fontSize: 16
              }
            },
            // label: {
            //   formatter:
            //       '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
            //   backgroundColor: '#F6F8FC',
            //   borderColor: '#8C8D8E',
            //   borderWidth: 1,
            //   borderRadius: 2,
            //   rich: {
            //     a: {
            //       color: '#6E7079',
            //       lineHeight: 22,
            //       align: 'center',
            //     },
            //     hr: {
            //       borderColor: '#8C8D8E',
            //       width: '100%',
            //       borderWidth: 1,
            //       height: 0,
            //     },
            //     b: {
            //       color: 'black',
            //       fontSize: 14,
            //       fontWeight: 'bold',
            //       lineHeight: 33,
            //     },
            //     per: {
            //       color: '#fff',
            //       backgroundColor: '#4C5058',
            //       padding: [3, 4],
            //       borderRadius: 4,
            //     },
            //   },
            // },
            data: [
              { value: 335, name: '天鹰聚能' },
              { value: 310, name: '康久消毒' },
              { value: 234, name: '七个蛋白' },
              { value: 135, name: '良中良' },
              { value: 1048, name: '山东喜迎人家' },
              { value: 251, name: '重庆嘉萱' },
              { value: 147, name: '上海瑞香' },
              { value: 123, name: '其他' },
            ],
          },
        ],
      };

      myChart.setOption(option);
    },
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    height: 20%;
    .titleDiv {
      width: 100%;
      align-items: center;
      display: flex;
      .tileSize {
        color: rgb(0, 186, 255);
        font-size: 20px;
        text-align: center;
        width:90%;
        margin: 0 auto
      }
    }
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 32%;
      height: 70px;
      .dv-dig-flop {
        width: 100%;
        height: 30px;
      }

    }
  }
  .down {
    margin-top: 10px;
    width: 100%;
    height: 450px;
  }
}
</style>
